import * as sc from "../DIGISIGN/digisignScript"
import { config } from "../CommonURLS";
import Sweetalert, { failureAlert, successAlertEsign } from "../SweetAlerts";
import Swal from "sweetalert2";
import { CommonAxiosPost } from "../CommonAxios";
export function digisignFunction(base64, pages, postData, getFunction, pageName) {

    let myObj = sc._elk_desksignObj
    let subjectName = "";
    let issuerName = "";
    let resellerCode = 75;
    let strHash;
    let signerName;
    let offset;
    let signerCert;
    let outfile;
    let res;
    const encodeFormData = (data) => {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
            .join('&');
    };
    function preInvoke(signingfn, callback) {
        if (!myObj._elk_initialized) {
            myObj._elk_initialize(callback);
            window.setTimeout(signingfn, 200);
        }
        else
            signingfn();
    }


    function signmem() {
        myObj.ConfigSigBlock(256, 20, 30, 1, 0, "Digitally signed by", 120, 120);
        myObj.SignDataInMemoryEx("04536563", "", true, true, 0, subjectName, issuerName, "", "", false, 0, resellerCode);

    }


    function mycallback2(apiName, status, params) {
        // alert("2")
        if (apiName != "SignDataInMemoryEx")
            return;
        if (status != "Success") {
            alert("Certificate operation failed: " + status);
            // handleClose();
        }
        else {
            if (apiName == "SignDataInMemoryEx") {
                // document.getElementById("sign_loading").innerHTML="<i class='fa fa-spinner fa-spin' ></i> Registering Signature......";
                var sigholder = params.sig;
                var x = "https://digisign.apcfss.in/services/Sign/doRegister";
                let payload = {
                    sig: sigholder,
                    tbsdata: '412445',
                    project: 'jnanabhumi',
                    pkey: 'Jnb@123',
                    token_name: 'Hypersecu'
                };



                fetch("https://digisign.apcfss.in/services/Sign/doRegister", {
                    method: 'POST',
                    body: encodeFormData(payload),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                    .then(response => response.text())
                    .then(data => {

                        let res1 = data.split("*~*");
                        if (res1[0] == 1) {
                            // document.getElementById("sign_sno").value = res1[1];
                            // dispatch({ type: "DIGITOKENNO", payload: res1[1] })
                            sessionStorage.setItem("sign_sno", res1[1])
                            preInvoke(signmem, mycallback);
                        }

                    })
                    .catch(error => {
                        console.error("Error:", error);
                        // handleClose()
                    });

            }
        }

    }


    function mycallback(apiName, status, params) {
        // let method_name = '<%=request.getAttribute("ack")%>';
        if (apiName == "SignDataInMemoryEx") {
            // alert("3")
            if (typeof params.sig == "undefined" || params.sig == "") {
                let retVal = "";
            }
            else {
                if (apiName == "SignDataInMemoryEx") {
                    let retVal = params.sig;
                    let signValue = params.sig;
                    var fileURL = base64;//document.getElementById("base64").value
                    var token_no = sessionStorage.getItem("sign_sno");
                    // console.log("first", token_no)

                    //document.getElementById("sign_sno").value;
                    // tokenNo;
                    //|| document.getElementById("token_sno").value;
                    //tokenNo//getData// token//;
                    var page = pages//document.getElementById("page").value;
                    //                 var oParameters = { "sig" :signValue,"MyReason":"", "MyLocation":"","SigBlockTitle":"", "PageNumber":page, "SigPosition":"10", "filetosign" :fileURL,"searchText":"Signature of Principal with college seal","coordinatex":"1",
                    // "coordinatey":"5","project":"jnanabhumi","pkey":"Jnb@123","token_name":"FT","token_sno":token_no};
                    let payload = {//
                        "sig": signValue,
                        "MyReason": "",
                        "MyLocation": "",
                        "SigBlockTitle": "",
                        "PageNumber": -1,
                        "SigPosition": "10",
                        "filetosign": fileURL,
                        "searchText": "Signature of Principal with college seal",
                        "coordinatex": "1",
                        "coordinatey": "5",
                        "project": "jnanabhumi",
                        "pkey": "Jnb@123",
                        "token_name": "FT",
                        "token_sno": token_no
                    }


                    if (token_no !== "" || token_no !== null) {
                        fetch("https://digisign.apcfss.in/services/Sign/getCert", {
                            method: 'POST',
                            body: encodeFormData(payload),
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                            }
                        }).then(response => response.text())
                            .then(data => {
                                var res1 = data.split("*~*");
                                strHash = res1[1];
                                signerName = res1[2];
                                var signerSubjectDN = signerName;
                                offset = res1[3];
                                signerCert = res1[4];
                                outfile = res1[5];
                                res = res1[0];
                                if (res == 1)
                                    myObj.SignEncodedDataInBatch(strHash, 1, 0, 0, signerSubjectDN, "", "", "", 1, 0, resellerCode);

                            })
                            .catch(error => {
                                console.error("Error:", error);
                                // handleClose()
                            });
                    } else {
                        Sweetalert("Your DSK ID Is Not Yet Registered / InActive", "error")
                    }
                }
            }
        }
        else if (apiName == "SignEncodedDataInBatch") {
            // alert("4")
            let signValue = params.sig;//
            let payload = {
                "signature": signValue,
                "offset": offset,
                "hash": strHash,
                "signerCert": signerCert,
                "outfile": outfile,
                "project": "jnanabhumi",
                "pkey": "Jnb@123",
                "res": res
            };

            fetch("https://digisign.apcfss.in/services/Sign/signHash", {
                method: 'POST',
                body: encodeFormData(payload),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
                .then(response => response.text())
                .then(data => {

                    let res1 = data.split("*~*");
                    let signfilecontent = res1[1];
                    // console.log("signed file content", signfilecontent, res1[0] == 1);

                    if (res1[0] == 1) {
                        let prevData = postData?.params
                        // let payload = {
                        //     finalPdf: signfilecontent,  // pdf init value send to backend
                        //     ...prevData
                        // }


                        // 🔥 IMPORTANT FIX (NO OVERWRITE ISSUE)
                        let finalPayload = {
                            // collCode: prevData?.collCode,
                            // nocType: prevData?.nocType,
                            // finalPdf: signfilecontent.replaceAll("\n", "")
                            stuIds: prevData?.stuIds,
                            pdfSign: signfilecontent.replaceAll("\n", "")
                        };
                        console.log("🚀 FINAL PAYLOAD>>>>>>>>>>>>>>>>:", finalPayload);
                        postSignedPdfPathFunction(finalPayload)

                    }

                })
                .catch(error => {
                    console.error("Error:", error);
                    // handleClose()
                });
        }
    }


    // function postSignedPdfPathFunction(payload) {
    //     let posturl = postData?.path
    //     console.log("post url", posturl, "payload for post signed pdf", payload)
    //     CommonAxiosPost(posturl, payload).then((res) => {
    //         if (res?.data?.ResponseCode === "01") {
    //             Swal.fire({
    //                 text: "File signed successfully",
    //                 icon: "success",
    //                 backdrop: false,
    //             }).then((result) => {
    //                 if (result.isConfirmed) {
    //                     navigate(-1);
    //                 }
    //             });
    //         }
    //         else {
    //             failureAlert(res?.data?.ResponseDesc)
    //         }
    //     });


    // }

    function postSignedPdfPathFunction(payload) {
        if (pageName === "SuperAdminDetails" && postData?.path) {
            // console.log("post url", postData?.path, "payload for post signed pdf", payload)
            const signedPdfValue = (payload?.pdfSign || "").replaceAll("\n", "");
            const finalPayload = {
                ...(postData?.params || {}),
                pdfSign: signedPdfValue,
            };

            CommonAxiosPost(postData.path, finalPayload, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then((res) => {
                    if (res?.data?.scode === "01" || res?.data?.status === true || res?.data?.ResponseCode === "01") {
                        Swal.fire({
                            text: "File signed successfully",
                            icon: "success",
                            backdrop: false,
                        }).then(() => {
                            if (typeof getFunction === "function") {
                                getFunction();
                            }
                        });
                    } else {
                        failureAlert(res?.data?.ResponseDesc || res?.data?.message || "Failed");
                    }
                })
                .catch((err) => {
                    console.error(err);
                    failureAlert("Server error");
                });

            return;
        }

        // if (payload.nocType === "shifting") {
        //     payload.finalPdf = payload.finalPdfPhysical || payload.finalPdf;
        // }
        // const endPoint = payload.nocType === "shifting" ? "updateJdFinalStatusPhysical" : "updateJdFinalStatus";
        const posturl = config.url.STU_URL + endPoint;

        // const posturl = config.url.STU_URL + "updateJdFinalStatus";

        console.log("FINAL PAYLOAD:", payload);

        CommonAxiosPost(posturl, payload, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                if (res?.data?.scode === "01" || res?.data?.ResponseCode === "01") {
                    Swal.fire({
                        text: "File signed successfully",
                        icon: "success",
                        backdrop: false,
                    }).then(() => {
                        window.location.reload();

                    });
                } else {
                    failureAlert(res?.data?.ResponseDesc || "Failed");
                }
            })
            .catch((err) => {
                console.error(err);
                failureAlert("Server error");
            });
    }



    return preInvoke(signmem, mycallback2);
}